import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import './anexo.styles.css';
import * as acessos from '../../../../../../acessos.const.util';
import Autosuggest from 'react-autosuggest';
import IntlMessage from "../../../../../../helpers/intlMessage";

const AnexoPage = (props) => (
  <div className='anexo-container'>
    <p className='title'><IntlMessage id = "dashboards.examDetail.Attachment"/></p>
    {props.modal &&
      props.acessoPermitido(props.usuario, acessos.Anexo) &&
      props.modal &&
      props.acessoPermitido(props.usuario, acessos.Adicionar) && (
        <Modal
          size='ie'
          isOpen={props.modal}
          toggle={() => props.cancelarUpload()}
        >
          <ModalHeader toggle={() => props.cancelarUpload()}>
            <IntlMessage id = "dashboards.examDetail.fileAttachment"/>
          </ModalHeader>
          <ModalBody>
            <div className='anexo-descricao'>
              <Label className='anexo-descricao-label'><IntlMessage id = "dashboards.disposalMaterials.description"/>: </Label>
              <Autosuggest
                suggestions={props.suggestions}
                onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={props.onSuggestionsClearRequested}
                getSuggestionValue={props.getSuggestionValue}
                renderSuggestion={props.renderSuggestion}
                inputProps={props.inputProps}
              />
            </div>
            <div>
              <i className='mv-basico-pdf'></i>
            </div>
            <div className='anexo-nome'>
              <a>{props.novoAnexo.name}</a>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={() => props.cancelarUpload()}>
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
            <Button
              color='primary'
              disabled={!props.existeDescricao()}
              onClick={() => props.upload()}
            >
               <IntlMessage id = "dashboards.examDetails.confirm"/>
            </Button>
          </ModalFooter>
        </Modal>
      )}
    {props.modalJustificativa && (
      <Modal
        isOpen={props.modalJustificativa}
        toggle={props.toggleModalJustificativa}
      >
        <ModalHeader
          toggle={props.toggleModalJustificativa}
        > <IntlMessage id = "dashboards.examDetail.deletearchive"/> {`${props.arquivo.nomeArquivo}`}</ModalHeader>
        <ModalBody>
          <Label><IntlMessage id = "dashboards.examDetails.justification"/></Label>
          <Input
            type='text'
            style={{ fontSize: '15px' }}
            onChange={props.setJustificativa}
            value={props.justificativa}
            maxLength={250}
          />
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={props.toggleModalJustificativa}>
          <IntlMessage id = "dashboards.examDetails.cancel"/>
          </Button>
          <Button
            color='primary'
            onClick={props.excluirAnexo}
            disabled={!props.justificativa || props.justificativa === ''}
          >
              <IntlMessage id = "dashboards.examDetails.confirm"/>
          </Button>
        </ModalFooter>
      </Modal>
    )}
    {props.acessoPermitido(props.usuario, acessos.Anexo) &&
      props.acessoPermitido(props.usuario, acessos.Adicionar) && (
        <Row>
          <Col>
            <div className='anexo-file'>
              <label htmlFor='anexo'><IntlMessage id = "dashboards.examDetail.selectarchive"/></label>
              <input
                id='anexo'
                type='file'
                ref={props.uploadInput}
                onChange={props.onChange2}
                accept='.odt,.jpg,.jpeg,.png,.doc,.docx,.pdf'
              />
            </div>
          </Col>
        </Row>
      )}
    <br />
    <Row>
      <div
        style={{
          height: `${props.altura - 156}px`,
          width: '100%',
          overflowY: 'scroll',
          overflowX: 'hidden',
        }}
      >
        {props.listagemAnexo !== null &&
          props.listagemAnexo.map((anexo) => {
            return (
              <Col sm='auto' key={anexo.id} style={{ float: 'left' }}>
                <Card style={{ minWidth: '130px', maxWidth: '500px' }}>
                  <CardBody>
                    <CardTitle>
                      <div className='anexo-lista'>
                        <i className='mv-basico-pdf'></i>
                        <div className='anexo-nome'>
                          <a>{anexo.nomeArquivo}</a>
                        </div>
                      </div>
                    </CardTitle>
                    <Row>
                      <Col size='500'>
                        <a style={{ fontSize: '12px', marginLeft: '10px' }}>
                          {anexo.descricao}
                        </a>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm='auto' style={{ marginTop: '20px' }}>
                        <div>
                          <Button
                            color='primary'
                            onClick={() =>
                              props.download(
                                anexo.id,
                                anexo.nomeArquivo,
                                anexo.extensao
                              )
                            }
                          >
                            <IntlMessage id = "dashboards.examDetail.download"/>
                          </Button>
                          <Button
                            color='danger'
                            disabled={
                              !props.acessoPermitido(
                                props.usuario,
                                acessos.Anexo
                              ) ||
                              !props.acessoPermitido(
                                props.usuario,
                                acessos.Apagar
                              )
                            }
                            onClick={() => props.excluir(anexo)}
                          >
                            <IntlMessage id = "general.materialArchiving.remove"/>
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
      </div>
    </Row>
  </div>
);

export default AnexoPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/anexo/anexo.page.js